import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { useT } from '../lib/LanguageContext';

export default function LoginScreen() {
  const { login } = useAuth();
  const t = useT();
  const [agreed, setAgreed] = useState(false);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-keep-page text-keep-text px-6"
      data-testid="login-screen"
    >
      <div className="max-w-md w-full text-center space-y-6">
        <img
          src="/logo192.png"
          alt="Recycle Brain"
          className="w-16 h-16 mx-auto rounded-2xl"
          data-testid="login-logo"
        />
        <div className="space-y-2">
          <h1 className="text-3xl font-medium">Recycle Brain</h1>
          <p className="text-keep-textMuted text-sm">{t('login.subtitle')}</p>
        </div>

        {/* Consent checkbox */}
        <label
          className="flex items-start gap-3 text-left px-3 py-3 rounded-lg border border-keep-border bg-keep-surface hover:bg-keep-hover cursor-pointer transition-colors"
          data-testid="login-consent-label"
        >
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="sr-only peer"
            data-testid="login-consent-checkbox"
          />
          <span
            className={`flex-shrink-0 w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center transition-colors ${
              agreed
                ? 'bg-keep-accent border-keep-accent'
                : 'border-keep-textMuted bg-keep-surface'
            }`}
            aria-hidden
          >
            {agreed && <Check className="w-3.5 h-3.5 text-keep-onAccent" strokeWidth={3} />}
          </span>
          <span className="text-[12.5px] leading-relaxed text-keep-textMuted">{t('login.consent')}</span>
        </label>

        <button
          type="button"
          onClick={login}
          disabled={!agreed}
          className="w-full inline-flex items-center justify-center gap-3 h-12 rounded-full bg-keep-surface border border-keep-topbarBorder hover:shadow-keep transition-all text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:shadow-none"
          data-testid="login-google-button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
            <path
              fill="#4285F4"
              d="M23.06 12.27c0-.86-.08-1.7-.22-2.5H12v4.73h6.21c-.27 1.42-1.06 2.62-2.27 3.43v2.83h3.67c2.15-1.98 3.45-4.92 3.45-8.49z"
            />
            <path
              fill="#34A853"
              d="M12 23.5c3.06 0 5.62-1.02 7.49-2.74l-3.67-2.83c-1.02.68-2.32 1.08-3.82 1.08-2.94 0-5.43-1.98-6.32-4.64H1.91v2.92A11.5 11.5 0 0 0 12 23.5z"
            />
            <path
              fill="#FBBC05"
              d="M5.68 14.37a6.92 6.92 0 0 1 0-4.74V6.71H1.91a11.5 11.5 0 0 0 0 10.58l3.77-2.92z"
            />
            <path
              fill="#EA4335"
              d="M12 4.62c1.66 0 3.16.57 4.34 1.69l3.25-3.25C17.62 1.2 15.06.5 12 .5A11.5 11.5 0 0 0 1.91 6.71l3.77 2.92C6.57 6.6 9.06 4.62 12 4.62z"
            />
          </svg>
          {t('login.continueWithGoogle')}
        </button>
        <p className="text-xs text-keep-textMuted">{t('login.footer')}</p>
      </div>
    </div>
  );
}
